var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-icon_svg__Icon_-_Home",
    "data-name": "Icon - Home",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-icon_svg__Group_1900",
    "data-name": "Group 1900",
    clipPath: "url(#home-icon_svg__clip-path)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "home-icon_svg__Path_5311",
    "data-name": "Path 5311",
    d: "M3.5 12.5v10h6v-7h5v7h6V13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-icon_svg__Path_5312",
    "data-name": "Path 5312",
    d: "M.5 12L12 .5 23.5 12",
    strokeLinejoin: "round"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgMjQgMjQiPgogIDxnIGlkPSJJY29uXy1fSG9tZSIgZGF0YS1uYW1lPSJJY29uIC0gSG9tZSIgb3BhY2l0eT0iMC41Ij4KICAgIDxnIGlkPSJHcm91cF8xOTAwIiBkYXRhLW5hbWU9Ikdyb3VwIDE5MDAiIGNsaXAtcGF0aD0idXJsKCNjbGlwLXBhdGgpIj4KICAgICAgPHBhdGggaWQ9IlBhdGhfNTMxMSIgZGF0YS1uYW1lPSJQYXRoIDUzMTEiIGQ9Ik0zLjUsMTIuNXYxMGg2di03aDV2N2g2VjEzIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIvPgogICAgICA8cGF0aCBpZD0iUGF0aF81MzEyIiBkYXRhLW5hbWU9IlBhdGggNTMxMiIgZD0iTS41LDEyLDEyLC41LDIzLjUsMTIiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
export { SvgHomeIcon as ReactComponent };